import type { VersionedStorageService } from "../../../services/versioned-storage";
import { preflightStorageKey } from "../preflight";

export interface NotepadResult {
  readonly issue: string | null;
  readonly text: string;
}

export function loadNotepad(
  storage: VersionedStorageService,
  fileHash: string,
): NotepadResult {
  const loaded = storage.load(preflightStorageKey("notepad", fileHash));
  if (!loaded.ok) {
    return loaded.error.problem === "record not found"
      ? { text: "", issue: null }
      : { text: "", issue: loaded.error.message };
  }
  const data = loaded.value.data;
  if (
    loaded.value.recordType !== "notepad" ||
    !("fileHash" in data) ||
    !("text" in data) ||
    data.fileHash !== fileHash
  ) {
    return {
      text: "",
      issue: "Stored notepad does not match the active orders file.",
    };
  }
  return { text: data.text, issue: null };
}

export function saveNotepad(
  storage: VersionedStorageService,
  fileHash: string,
  text: string,
): string | null {
  const saved = storage.save(
    "notepad",
    preflightStorageKey("notepad", fileHash),
    { fileHash, text },
  );
  return saved.ok ? null : saved.error.message;
}
